export default "__VITE_ASSET__mc0CHrcO__"